export const SUCCESS_NOTIFICATION_REQUEST = "SUCCESS_NOTIFICATION_REQUEST";
export const RESET_NOTIFICATION_SUCCESS = "RESET_NOTIFICATION_SUCCESS";
export const ERROR_NOTIFICATION_REQUEST = "ERROR_NOTIFICATION_REQUEST";
export const RESET_NOTIFICATION_DATA = "RESET_NOTIFICATION_DATA";
export const SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE";